var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomePageHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 180,
    viewBox: "0 0 288 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_702_1906",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 288,
    height: 180
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.856445,
    width: 286.286,
    height: 180,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_702_1906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.5643 101.787C97.5643 101.787 96.7297 107.898 97.5643 111.052C98.3988 114.206 107.678 144.533 107.678 144.533L112.303 131.053L110.408 103.428L97.5643 101.787Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.133 121.73C111.133 121.73 106.267 147.192 106.804 153.373C107.342 159.554 110.864 176.359 110.864 176.359L117.088 218.016L118.431 248.3L134.387 247.763C134.387 247.763 135.476 212.612 134.939 209.571C134.401 206.53 133.524 146.286 133.524 146.286L138.39 146.018L142.238 210.929L144.939 246.08L154.134 243.647L162.522 243.916C162.522 243.916 162.253 210.929 162.253 207.407C162.253 203.885 161.432 193.078 161.432 191.183C161.432 189.287 161.164 133.301 161.164 133.301L159.82 122.494L111.133 121.73Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.028 49.5198L105.729 56.2811C105.267 61.6255 105.447 67.006 106.266 72.3075C107.681 80.4267 110.057 112.069 110.057 112.069C110.057 112.069 108.43 123.159 110.594 124.503C112.759 125.847 153.327 125.323 156.566 125.054C159.805 124.786 161.432 120.457 161.432 117.473C161.432 114.488 158.999 105.577 158.999 105.577L162.252 52.5044L141.148 47.9072L123.028 49.5198Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.654 46.5501L120.595 49.7893L124.386 70.0733L133.58 58.7149L145.207 69.8046V48.4455L138.983 45.4609L124.654 46.5501Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.027 40.0573L124.116 50.3408L133.848 64.6697L141.147 47.8937L140.072 38.4307L123.027 40.0573Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.489 5.95345C122.489 5.95345 116.024 7.21236 115.812 13.2806C115.6 19.3488 117.51 29.1513 118.641 33.4514C119.773 37.7515 123.238 46.3517 128.076 46.6064C132.914 46.861 138.062 46.6064 140.453 40.6937C142.843 34.7811 141.867 24.1723 140.255 19.4761C138.642 14.78 137.624 9.6736 134.823 6.6607C132.022 3.6478 126.067 4.82184 122.489 5.95345Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.057 24.5817C117.057 24.5817 114.228 22.0497 113.931 24.9636C113.634 27.8775 118.669 33.4506 118.669 33.4506L117.057 24.5817Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.724 20.3108C140.724 20.3108 141.162 19.2075 142.067 19.5611C142.973 19.9147 143.34 21.5556 143.34 24.0168C143.263 25.7855 142.88 27.5275 142.209 29.1656L140.724 20.3108Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.024 24.2858C126.024 25.0921 125.656 25.7003 125.119 25.7852C124.581 25.8701 124.128 25.177 124.086 24.3707C124.044 23.5644 124.454 22.9562 124.991 22.8713C125.529 22.7864 125.996 23.4796 126.024 24.2858Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.857 22.6159C135.857 23.4222 135.49 24.1011 134.952 24.1153C134.415 24.1294 133.948 23.507 133.905 22.7008C133.863 21.8945 134.273 21.2863 134.811 21.2014C135.348 21.1165 135.815 21.8096 135.857 22.6159Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.634 22.1504C121.236 21.4492 121.997 20.9013 122.853 20.552C123.709 20.2028 124.635 20.0622 125.556 20.1418",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.074 19.0941C131.952 18.5244 132.945 18.1566 133.982 18.0172C135.019 17.8777 136.075 17.9702 137.072 18.2879",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.283 19.4201C138.713 14.9361 137.751 10.2399 135.318 7.18457C135.318 7.63721 135.431 8.11815 135.46 8.68395C135.615 12.2344 135.233 14.5259 136.577 15.4311C137.921 16.3364 139.208 16.294 139.251 17.2559C139.293 18.2177 140.665 25.9692 141.019 28.3597C140.792 29.8874 140.354 34.3855 140.354 34.3855C140.354 34.3855 136.761 30.34 134.328 30.142C131.895 29.944 130.382 29.0245 127.878 30.92C126.86 31.2634 125.981 31.9287 125.374 32.8154C124.905 33.6604 124.512 34.5456 124.2 35.4606C124.2 35.4606 119.363 32.6315 118.655 31.019C117.934 28.5002 117.489 25.9107 117.326 23.2958C117.326 22.3198 119.136 20.4668 118.358 17.4114C117.755 15.6111 116.933 13.8914 115.911 12.2909C115.911 12.6163 115.826 12.9416 115.812 13.2952C115.614 19.3493 117.51 29.166 118.641 33.4661C119.773 37.7662 123.238 46.3664 128.076 46.621C132.914 46.8756 138.062 46.621 140.453 40.7084C142.843 34.7957 141.952 24.2152 140.283 19.4201Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.209 36.4933C133.173 36.8677 132.998 37.2151 132.72 37.4679C132.441 37.7207 132.079 37.8607 131.703 37.8607C131.327 37.8607 130.964 37.7207 130.686 37.4679C130.407 37.2151 130.233 36.8677 130.196 36.4933C130.233 36.119 130.407 35.7716 130.686 35.5188C130.964 35.266 131.327 35.126 131.703 35.126C132.079 35.126 132.441 35.266 132.72 35.5188C132.998 35.7716 133.173 36.119 133.209 36.4933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.552 6.61767C123.381 8.32922 125.333 9.44668 127.016 8.2585C128.148 7.45223 129.322 5.82555 130.538 4.76467C127.805 4.66206 125.076 5.06487 122.49 5.95285C121.822 6.10686 121.173 6.32965 120.552 6.61767Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.676 29.3347C126.861 30.0258 127.251 30.6449 127.793 31.1116C128.336 31.5784 129.006 31.871 129.717 31.9516C132.15 32.1638 132.546 27.9344 132.419 27.2979",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.676 29.3347C126.861 30.0258 127.251 30.6449 127.793 31.1116C128.336 31.5784 129.006 31.871 129.717 31.9516C132.15 32.1638 132.546 27.9344 132.419 27.2979",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.727 56.2822L96.5322 100.91L109.235 103.343L105.727 56.2822Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5327 95.5059L95.1748 103.073L109.773 106.044L108.697 99.2826L96.5327 95.5059Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.249 52.5039L188.885 64.4565C188.885 64.4565 189.903 68.7 188.036 71.727C186.169 74.7541 179.068 76.1262 174.839 75.2775C170.609 74.4287 161.302 70.3691 161.302 70.3691L162.249 52.5039Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.127 58.4032C176.127 58.4032 171.063 63.6652 170.851 65.7728C170.639 67.8804 175.703 76.0846 179.069 76.9333C182.436 77.782 189.593 75.25 191.489 72.9302C193.384 70.6104 193.384 62.4063 189.395 59.6622C185.406 56.918 177.811 56.9322 176.127 58.4032Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.116 58.4601C186.169 57.2861 167.441 40.8071 167.441 40.8071C167.441 40.8071 168.968 37.0728 169.449 35.729C169.93 34.3852 169.124 33.3951 170.001 29.8447C170.878 26.2943 169.831 26.2377 168.219 27.2278C166.606 28.218 165.899 32.4191 165.899 32.4191L161.995 27.2986L158.006 20.8626C157.803 20.5475 157.488 20.3208 157.125 20.2279C156.762 20.1351 156.377 20.1829 156.048 20.3619C155.719 20.5409 155.469 20.8377 155.35 21.1929C155.23 21.5481 155.249 21.9354 155.403 22.2771L158.529 29.3496L158.232 29.6325L152.051 22.8004C151.923 22.6522 151.767 22.5321 151.59 22.4476C151.414 22.363 151.222 22.3159 151.027 22.3093C150.831 22.3027 150.637 22.3366 150.455 22.4089C150.273 22.4813 150.109 22.5905 149.972 22.7297C149.749 22.9597 149.611 23.2584 149.58 23.577C149.549 23.8956 149.627 24.2153 149.802 24.4837L155.46 32.0796L155.219 32.3201C154.173 31.5421 150.976 29.0667 150.184 28.4867C149.392 27.9068 148.161 26.6762 147.425 27.8785C146.69 29.0808 147.807 29.5052 148.472 30.1276C149.519 31.1036 151.188 32.9566 152.221 33.9892C151.188 33.5082 147.242 31.8391 146.817 32.2352C146.651 32.4387 146.568 32.697 146.584 32.959C146.6 33.221 146.713 33.4675 146.902 33.6497C147.131 33.83 147.389 33.9689 147.666 34.0599C150.068 35.1082 152.222 36.6505 153.989 38.5863C155.403 40.0008 157.129 41.288 158.628 42.6884C159.618 43.622 160.962 44.796 160.962 44.796C160.962 44.796 176.281 70.7522 181.232 72.8739C186.183 74.9957 190.426 68.1495 190.426 64.8537C190.426 61.5579 188.064 59.5776 187.116 58.4601Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9566 110.019C52.5453 117.265 49.0439 125.028 46.5317 133.132C41.7082 147.857 44.127 183.361 44.127 183.361C47.8349 185.186 51.8401 186.331 55.9523 186.741C59.6338 187.055 63.3275 186.299 66.5893 184.563L69.7295 144.716L71.4128 144.235L74.0721 184.818C74.0721 184.818 77.4527 185.299 84.9355 186.232C92.4182 187.166 99.1654 182.399 99.1654 182.399C99.1654 182.399 96.3364 135.536 93.3659 127.332C90.3955 119.128 86.4349 110.57 86.4349 110.57L56.9566 110.019Z",
    fill: "#514C9F",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7031 179.556L74.0426 184.818C74.0426 184.818 77.4233 185.299 84.906 186.233C92.3888 187.166 99.1642 182.4 99.1642 182.4C99.1642 182.4 99.0228 180.179 98.7823 176.614C91.066 180.636 82.1409 181.683 73.7031 179.556Z",
    fill: "#514C9F",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9704 179.584C59.4611 182.174 51.2736 181.993 43.8857 179.075C44.013 181.749 44.1262 183.319 44.1262 183.319C47.8341 185.144 51.8393 186.289 55.9515 186.699C59.633 187.013 63.3267 186.257 66.5885 184.521L66.9704 179.584Z",
    fill: "#514C9F",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9958 59.3369C68.9958 59.3369 53.4787 61.2182 51.074 65.2354C48.6693 69.2526 56.9442 110.118 56.9442 110.118L86.3942 110.613C86.3942 110.613 95.8007 71.8977 97.3 66.8338C98.7994 61.7699 80.3967 59.8603 80.3967 59.8603L68.9958 59.3369Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8316 64.3301L37.1816 100.895C37.1816 100.895 37.408 108.123 43.7874 107.374L53.5333 90.0882L50.8316 64.3301Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7568 84.2322L51.7107 93.3274L53.5354 90.0882L50.8337 64.3301L42.7568 84.2322Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7524 65.8438C97.7524 65.8438 105.9 103.116 105.815 107.826C105.73 112.537 99.8601 111.391 97.5827 110.33C95.3053 109.269 91.3447 90.5269 91.3447 90.5269L97.7524 65.8438Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7524 65.8438L91.3447 90.541C91.3447 90.541 91.6135 91.8141 92.052 93.7095H92.1227L102.024 86.1419C99.8883 75.8019 97.7524 65.8438 97.7524 65.8438Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9468 106.835C97.9468 106.835 94.8066 117.614 94.8066 122.777C94.8066 127.94 94.1276 143.655 94.1276 143.655C94.1276 143.655 90.9874 145.904 90.9874 148.153C90.9874 150.402 90.3084 151.972 90.3084 153.09C90.3084 154.207 89.8699 155.565 90.9874 155.565C92.1048 155.565 93.0101 151.067 93.0101 151.067C93.0101 151.067 91.8785 158.253 91.8785 159.554C91.8785 160.855 93.675 160.685 94.5802 160.007C96.7369 157.545 98.3429 154.652 99.2905 151.519C99.7432 148.832 99.2905 143.216 99.9695 142.311C102.613 135.237 104.644 127.949 106.038 120.528C106.703 114.87 105.359 105.718 105.359 105.718",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9468 106.835C97.9468 106.835 94.8066 117.614 94.8066 122.777C94.8066 127.94 94.1276 143.655 94.1276 143.655C94.1276 143.655 90.9874 145.904 90.9874 148.153C90.9874 150.402 90.3084 151.972 90.3084 153.09C90.3084 154.207 89.8699 155.565 90.9874 155.565C92.1048 155.565 93.0101 151.067 93.0101 151.067C93.0101 151.067 91.8785 158.253 91.8785 159.554C91.8785 160.855 93.675 160.685 94.5802 160.007C96.7369 157.545 98.3429 154.652 99.2905 151.519C99.7432 148.832 99.2905 143.216 99.9695 142.311C102.613 135.237 104.644 127.949 106.038 120.528C106.703 114.87 105.359 105.718 105.359 105.718",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9086 100.753C41.9086 100.753 30.0126 85.1936 27.9474 81.7139C25.8822 78.2342 25.2457 75.1223 23.2512 73.7927C21.2568 72.463 15.4149 72.0953 14.2974 72.1236C13.18 72.1519 12.3595 81.3744 14.9057 82.6758C17.4323 83.6347 20.0877 84.2116 22.7845 84.3873C22.7845 84.3873 30.6916 105.831 33.8883 110.188C37.0851 114.545 40.3809 113.017 41.6822 110.499C42.9836 107.981 46.1804 103.115 46.1804 103.115",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9086 100.753C41.9086 100.753 30.0126 85.1936 27.9474 81.7139C25.8822 78.2342 25.2457 75.1223 23.2512 73.7927C21.2568 72.463 15.4149 72.0953 14.2974 72.1236C13.18 72.1519 12.3595 81.3744 14.9057 82.6758C17.4323 83.6347 20.0877 84.2116 22.7845 84.3873C22.7845 84.3873 30.6916 105.831 33.8883 110.188C37.0851 114.545 40.3809 113.017 41.6822 110.499C42.9836 107.981 46.1804 103.115 46.1804 103.115",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.61 76.7779C25.61 76.7779 22.9224 71.0208 22.3001 68.8142C21.6777 66.6076 22.102 62.7036 20.7299 63.0289C19.3579 63.3542 17.7737 66.452 18.3819 68.107C18.7469 69.0986 19.0585 70.109 19.3154 71.134C19.3154 71.134 18.693 77.8388 22.1444 79.3947",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.61 76.7779C25.61 76.7779 22.9224 71.0208 22.3001 68.8142C21.6777 66.6076 22.102 62.7036 20.7299 63.0289C19.3579 63.3542 17.7737 66.452 18.3819 68.107C18.7469 69.0986 19.0585 70.109 19.3154 71.134C19.3154 71.134 18.693 77.8388 22.1444 79.3947",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4664 69.8752C11.4664 69.8752 10.2358 72.2233 12.1454 72.7042C14.0549 73.1852 16.9405 73.4256 17.3366 72.1101C17.7326 70.7946 17.3366 70.0874 16.403 69.8186C14.7819 69.3962 13.0773 69.4158 11.4664 69.8752Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8068 73.9203C11.8068 73.9203 10.5762 76.2825 12.4716 76.7493C14.3671 77.2161 17.281 77.4707 17.6629 76.1552C18.0448 74.8397 17.6629 74.1324 16.7293 73.8637C15.1131 73.4411 13.4129 73.4607 11.8068 73.9203Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2004 77.3851C12.2004 77.3851 10.9698 79.7473 12.8652 80.2141C14.7606 80.6809 17.6745 80.9355 18.0706 79.62C18.4667 78.3045 17.9999 77.5973 17.1229 77.3285C15.5066 76.906 13.8065 76.9255 12.2004 77.3851Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3893 80.5123C13.3893 80.5123 12.3567 82.4784 13.9409 82.9169C15.5252 83.3554 17.9723 83.511 18.2976 82.4219C18.6229 81.3327 18.2976 80.7103 17.5055 80.4981C16.158 80.1261 14.7342 80.131 13.3893 80.5123Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9586 11.6962C76.9586 11.6962 76.5343 11.6962 75.8129 11.5689C72.7576 11.3285 64.313 11.3709 59.9846 18.5425C54.6519 27.4114 57.2404 52.8584 57.2404 52.8584L92.9426 52.4057C92.9426 52.4057 93.5225 34.201 91.4573 23.7761C89.3921 13.3512 76.9586 11.6962 76.9586 11.6962Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3728 54.6403C68.3728 54.6403 64.5678 55.8143 63.9454 58.1058C63.323 60.3973 65.3599 74.4434 65.3599 74.4434L74.243 67.7811L83.3241 75.6033C83.3241 75.6033 85.842 63.3678 84.9084 59.2657C83.9748 55.1637 77.7793 53.7774 76.676 53.9189L68.3728 54.6403Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0908 45.4463L68.5435 59.6479L74.2156 72.817L81.1892 57.3847L82.1086 46.1253L68.0908 45.4463Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6006 32.9699C62.6006 32.9699 64.5243 50.9766 73.4357 52.0092C82.3471 53.0418 85.9258 39.1655 85.8692 35.5019C85.8767 33.7328 85.7632 31.9653 85.5297 30.2116L73.6762 21.7246L62.6006 32.9699Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9698 36.8611C62.9698 36.8611 59.7731 36.267 60.3247 39.5628C60.8764 42.8586 64.5682 43.0707 64.5682 43.0707L62.9698 36.8611Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8706 35.5317C85.8706 35.5317 88.3743 33.7069 88.9401 36.9462C89.5059 40.1854 84.9795 41.8545 84.9795 41.8545L85.8706 35.5317Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1549 33.9604C70.1549 34.7242 69.8012 35.3749 69.3203 35.3749C68.8394 35.3749 68.4292 34.795 68.4009 33.9604C68.3726 33.1258 68.7545 32.5459 69.2354 32.5459C69.7164 32.5459 70.1266 33.2107 70.1549 33.9604Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5162 33.6635C79.5162 34.4274 79.1626 35.078 78.6816 35.078C78.2007 35.078 77.7905 34.4839 77.7622 33.6635C77.7339 32.8431 78.1158 32.249 78.5968 32.249C79.0777 32.249 79.4879 32.9138 79.5162 33.6635Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8223 39.5479C72.376 40.0938 73.103 40.4293 73.8777 40.4965C74.6525 40.5636 75.4264 40.3582 76.0658 39.9156",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0713 31.4428C67.6354 31.0281 68.2903 30.7539 68.9816 30.6432C69.6729 30.5325 70.3807 30.5884 71.046 30.8063",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5322 30.6369C76.5322 30.6369 80.0119 30.2833 81.5679 31.7261",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.959 43.085C71.3108 43.5067 71.751 43.846 72.2484 44.0789C72.7458 44.3117 73.2883 44.4324 73.8375 44.4324C74.3867 44.4324 74.9292 44.3117 75.4266 44.0789C75.924 43.846 76.3642 43.5067 76.716 43.085",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.382 56.9102C262.382 56.9102 276.81 98.1147 276.81 100.038C276.81 101.962 277.149 104.084 274.349 105.824C271.548 107.564 266.639 107.238 265.055 103.9C264.201 102.131 263.44 100.318 262.778 98.4684L262.382 56.9102Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.729 169.563L216.667 235.747L213.06 241.858C212.916 243.713 212.916 245.576 213.06 247.431C213.251 248.362 213.341 249.31 213.328 250.26L230.571 251.929C231.418 249.01 232.07 246.038 232.523 243.032C232.792 239.977 230.854 234.97 230.854 234.97L234.192 169.351L214.729 169.563Z",
    fill: "#514C9F",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.664 169.563L256.726 235.747L260.348 241.858C260.484 243.713 260.484 245.576 260.348 247.431C260.146 248.36 260.051 249.31 260.065 250.26L242.822 251.929C241.975 249.011 241.327 246.039 240.884 243.032C240.601 239.977 242.553 234.97 242.553 234.97L239.215 169.351L258.664 169.563Z",
    fill: "#514C9F",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.929 54.1113L201.758 62.8671L208.25 126.704L207.543 172.293H263.826L263.133 125.997L262.426 56.912L242.793 54.6347L221.929 54.1113Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.377 113.958L236.23 172.165",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.493 128.599H229.368V130.636H213.243",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.4 128.599H242.539V130.636H258.664",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.559 52.1728L221.928 54.1107L231.575 76.7286L243.485 54.9876L240.514 51.6494L224.559 52.1728Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.713 66.5588L231.744 61.2969L236.822 66.7286",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.191 47.2647L224.361 53.2339L231.731 61.2966L240.501 51.6497L240.147 37.2783C240.147 37.2783 235.239 44.1104 232.084 45.5107C229.548 46.462 226.892 47.0525 224.191 47.2647Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.112 23.7691C218.912 23.6671 218.719 23.5537 218.532 23.4296C217.344 22.7223 214.869 20.9259 215.279 18.5071C215.802 15.3528 223.158 9.92105 231.404 10.6142C239.651 11.3073 242.975 16.7531 243.498 20.9683C244.022 25.1836 241.744 33.2321 241.744 33.2321L239.651 32.7087L236.822 24.2217C233.149 24.558 229.461 24.676 225.774 24.5753C223.497 24.2924 219.112 23.7691 219.112 23.7691Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.535 21.3213C218.535 21.3213 218.181 35.339 219.242 38.4934C220.303 41.6477 221.52 48.3949 225.721 49.5407C229.922 50.6864 234.675 48.1262 236.952 46.3863C239.229 44.6465 240.106 37.97 240.106 37.97C240.106 37.97 243.091 36.7394 243.091 34.1084C243.093 33.3645 242.899 32.6331 242.529 31.9876C242.159 31.3421 241.626 30.8052 240.983 30.4307H239.569L238.338 21.8447C238.338 21.8447 227.531 25.1687 218.535 21.3213Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.606 29.3848L225.96 32.3552L225.083 40.6018L228.761 40.9554",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.897 42.8789C225.858 43.4366 226.948 43.7304 228.059 43.7304C229.169 43.7304 230.26 43.4366 231.22 42.8789",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.406 32.4545C225.406 33.2014 225.184 33.9316 224.77 34.5527C224.355 35.1738 223.765 35.6579 223.075 35.9437C222.384 36.2296 221.625 36.3044 220.892 36.1586C220.16 36.0129 219.487 35.6532 218.959 35.125C218.431 34.5968 218.071 33.9239 217.925 33.1913C217.779 32.4587 217.854 31.6993 218.14 31.0092C218.426 30.3191 218.91 29.7292 219.531 29.3142C220.152 28.8992 220.882 28.6777 221.629 28.6777C222.631 28.6777 223.592 29.0756 224.3 29.7839C225.008 30.4922 225.406 31.4528 225.406 32.4545Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.507 32.4545C235.507 33.2021 235.285 33.9328 234.869 34.5542C234.453 35.1756 233.863 35.6596 233.172 35.9451C232.481 36.2305 231.721 36.3045 230.988 36.1576C230.255 36.0107 229.582 35.6496 229.054 35.12C228.527 34.5904 228.168 33.9161 228.024 33.1826C227.88 32.449 227.957 31.6892 228.245 30.9994C228.533 30.3095 229.019 29.7207 229.642 29.3074C230.265 28.8941 230.996 28.675 231.744 28.6778C232.239 28.6778 232.73 28.7755 233.187 28.9655C233.645 29.1555 234.06 29.4339 234.41 29.7848C234.759 30.1357 235.036 30.5521 235.224 31.0103C235.413 31.4684 235.508 31.9592 235.507 32.4545Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.438 30.7852H227.715",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.775 31.4935L239.637 30.4326",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.174 27.673C220.174 27.673 222.805 26.2585 224.205 27.8428",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.066 27.8009C229.009 27.2981 230.061 27.0352 231.129 27.0352C232.197 27.0352 233.249 27.2981 234.191 27.8009",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.778 32.1017C222.778 32.7666 222.424 33.3041 221.972 33.3041C221.519 33.3041 221.18 32.7666 221.18 32.1017C221.18 31.4369 221.533 30.8994 221.972 30.8994C222.41 30.8994 222.778 31.4369 222.778 32.1017Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.868 32.1017C230.868 32.7666 230.514 33.3041 230.062 33.3041C229.609 33.3041 229.27 32.7666 229.27 32.1017C229.27 31.4369 229.623 30.8994 230.062 30.8994C230.5 30.8994 230.868 31.4369 230.868 32.1017Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.757 62.8662L191.771 110.04C191.771 110.04 192.987 116.349 195.448 116.349C198.885 115.801 202.135 114.417 204.911 112.317C205.972 111.087 205.619 103.83 205.619 103.83L201.757 62.8662Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.56 52.1729C224.56 52.1729 219.949 53.8985 218.803 57.3782C218.103 60.4759 217.856 63.6585 218.068 66.8271",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.829 77.4209C221.829 82.3434 221.589 87.2234 221.589 87.6336C221.589 88.3692 216.949 94.494 216.949 94.494",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.705 77.6066C215.295 73.7874 214.955 70.0814 214.955 68.7234C214.955 65.5691 220.146 64.4799 221.25 67.606C221.773 69.0205 221.886 73.264 221.872 77.4227",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.811 93.744C221.427 92.0141 219.137 90.1584 216.95 88.185C216.851 87.8738 216.201 82.6401 215.663 77.6045",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.056 81.6805C249.618 81.6805 250.885 80.4139 250.885 78.8515C250.885 77.2891 249.618 76.0225 248.056 76.0225C246.493 76.0225 245.227 77.2891 245.227 78.8515C245.227 80.4139 246.493 81.6805 248.056 81.6805Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.381 52.7939C242.381 52.7939 247.176 57.2213 247.883 76.3596",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.222 96.8859L226.314 92.501L227.007 104.425L219.991 106.717L221.222 96.8859Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.402 102.146C193.17 105.232 192.398 108.482 192.11 111.793C192.11 115.654 194.572 119.332 197.768 118.865C200.965 118.398 221.263 109.388 221.263 109.388V96.9404L198.476 100.972",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.402 102.146C193.17 105.232 192.398 108.482 192.11 111.793C192.11 115.654 194.572 119.332 197.768 118.865C200.965 118.398 221.263 109.388 221.263 109.388V96.9404L198.476 100.972",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.006 110.917L224.021 81.2832L248.747 79.0059L251.024 110.21L227.006 110.917Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.498 80.5753V77.7745L238.053 77.4209L238.406 80.0519L233.498 80.5753Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.484 100.039L242.819 99.9118L239.99 99.346C239.27 97.7161 238.448 96.1334 237.529 94.6074C237.005 94.0841 234.191 94.0841 232.974 93.9143C231.758 93.7446 230.513 91.4531 229.848 92.7403C229.183 94.0275 229.664 94.1548 230.018 94.664C230.818 95.2209 231.708 95.6371 232.649 95.8946L233.002 97.3091H223.525C223.525 97.3091 222.111 98.1861 223.525 98.8934L224.94 99.5865C224.94 99.5865 225.647 105.372 226.878 105.725C230.534 106.256 234.234 106.432 237.925 106.249C239.339 105.895 244.587 105.556 244.587 105.556L243.484 100.039Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.872 95.839C275.939 97.7278 276.599 99.8189 276.81 101.978C277.333 106.009 274.179 108.287 268.917 109.333C263.655 110.38 242.438 110.041 242.438 110.041L242.607 98.9933L268.917 95.4854",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.872 95.839C275.939 97.7278 276.599 99.8189 276.81 101.978C277.333 106.009 274.179 108.287 268.917 109.333C263.655 110.38 242.438 110.041 242.438 110.041L242.607 98.9933L268.917 95.4854",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageHero);
export default __webpack_public_path__ + "static/media/homePageHero.7ad2b8c87e60ebc662f49f23db1d6176.svg";
export { ForwardRef as ReactComponent };